import React from 'react';
import styled, { css } from 'styled-components';
import HorizontalSearchResults from '../../../molecules/HorizontalSearchResults';
import HorizontalSearchBar from '../../../molecules/HorizontalSearchBar';
import useDesktopSearchLogic from './useDesktopSearchLogic';

// DEPRECATED

const StyledDesktopContainer = styled.div`
  background-color: ${props => props.theme.background.background100};
  padding: ${props => `${props.theme.padding.normal}`};
  position: relative;
  width: 100%;

  /** FOCUSED INPUT */
  ${props =>
    props.focusedInput
      ? css`
          border-radius: ${`
            ${props.searchBarHeight / 2}px
            ${props.searchBarHeight / 2}px 0 0
          `};
        `
      : css`
          border-radius: ${`${props.searchBarHeight / 2}px`};
          box-shadow: ${props.theme.shadows[8]};
        `}
`;

const StyledHorizontalSearchResults = styled(HorizontalSearchResults)`
  background-color: ${props => props.theme.background.normal};
  left: 0;
  padding: ${props =>
    `${props.theme.padding.medium} ${props.theme.padding.xlarge}`};
  position: absolute;
  &:before {
    border-radius: ${props =>
      `0 0 ${props.searchBarHeight / 2}px ${props.searchBarHeight / 2}px`};
    box-shadow: ${props => props.theme.shadows[12]};
    content: '';
    position: absolute;
    top: 5px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  /** SEARCH BAR HEIGHT */
  border-radius: ${props =>
    `0 0 ${props.searchBarHeight / 2}px ${props.searchBarHeight / 2}px`};
  top: ${props => `${props.searchBarHeight}px`};
`;

const DesktopSearch = () => {
  const {
    focusedInput,
    handleBlur,
    inputContainerRef,
    searchBarHeight,
  } = useDesktopSearchLogic();

  const handleSearch = () => {};

  const handleSearchResults = () => {};

  return (
    <StyledDesktopContainer
      focusedInput={focusedInput}
      onBlur={handleBlur}
      ref={inputContainerRef}
      searchBarHeight={searchBarHeight}
      tabIndex={-1}
    >
      <HorizontalSearchBar onSearch={handleSearch} />
      <StyledHorizontalSearchResults
        searchBarHeight={searchBarHeight}
        handleSearchResults={handleSearchResults}
      />
    </StyledDesktopContainer>
  );
};

export default DesktopSearch;
